import React from 'react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-119">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0B1029] via-[#1A2352] to-[#0B1029] -z-10" data-id="element-120" />
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-[#F5D0A9]/10 via-transparent to-transparent -z-10" data-id="element-121" />

      <div className="container mx-auto px-6 max-w-6xl" data-id="element-122">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-123">
          <FadeIn data-id="element-124">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-[1.15] mb-6 text-white" data-id="element-125">
              The 3:04 AM Wake-Up Call Is Not Your Fault{' '}
              <br className="hidden md:block" data-id="element-126" />
              <span className="text-[#F5D0A9] italic text-3xl md:text-4xl lg:text-5xl" data-id="element-127">
                (And It's Not Just "Aging")
              </span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 mb-10 leading-relaxed max-w-xl font-light" data-id="element-128">
              The Hormonal "Core Temp Reset" to stop the cortisol spikes, end
              night sweats, and finally sleep through the night.
            </p>
            <a href="#offer" className="inline-block bg-[#F5D0A9] text-[#0B1029] px-8 py-4 rounded-full font-medium text-lg hover:bg-white transition-all duration-300 shadow-[0_0_20px_rgba(245,208,169,0.2)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] hover:-translate-y-0.5" data-id="element-129">
              Get The 3:00 AM Sleep Fix Now
            </a>
            <noscript data-id="element-130">
              <img height="1" width="1" style={{
              display: 'none'
            }} src="https://www.facebook.com/tr?id=988100866966932&ev=PageView&noscript=1" alt="" data-id="element-131" />
            </noscript>
          </FadeIn>

          <FadeIn delay={0.2} className="relative mt-10 lg:mt-0" data-id="element-132">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/60 aspect-square max-w-md mx-auto border border-white/10" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/tnyaDBjaWjkk5vFzMb9LwJ/TheMenopauseAndropause_Sleep_Fix-Image.png" alt="The 3:00 AM Sleep Fix Audiobook Cover" className="w-full h-full object-cover" data-id="element-134" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1029]/60 via-transparent to-transparent mix-blend-multiply" data-id="element-135" />
            </div>
            {/* Decorative glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[radial-gradient(circle,_var(--tw-gradient-stops))] from-[#F5D0A9]/15 to-transparent blur-3xl -z-10 rounded-full" data-id="element-136" />
          </FadeIn>
        </div>
      </div>
    </section>;
}